import { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DisplayGroupForm, { DisplayGroupFormRef } from "@/components/admin/displayGroup/DisplayGroupForm";
import PageHeader from "@/components/admin/header/PageHeader";
import SubmitAndCancelButtons from "@/components/admin/SubmitAndCancelButtons";
import { routes } from "@/configs/router.config/routes";
import { useDisplayGroups } from "@/hooks/useDisplayGroups";
import { useLandingPaths } from "@/hooks/useLandingPaths";
import { useWorkspaceRedirect } from "@/hooks/useWorkspaceRedirect";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { DisplayGroup } from "@/models/displayGroup";

const DisplayGroupEditPage: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { sessionCurrentWorkspaceId } = useWorkspaces();
  const { getDisplayGroup, updateDisplayGroup, isLoading: isLoadingDisplayGroup } = useDisplayGroups();
  const { landingPaths, isLoading: isLoadingLandingPaths } = useLandingPaths();
  const formRef = useRef<DisplayGroupFormRef>(null);

  // ワークスペース切り替え時に表示グループ一覧ページにリダイレクト
  useWorkspaceRedirect((workspaceId) => routes.displayGroup(workspaceId));

  const isLoading = isLoadingDisplayGroup || isLoadingLandingPaths;
  const displayGroup = id ? getDisplayGroup(id) : undefined;

  const handleUpdateDisplayGroup = async (name: string, paths: string[]) => {
    if (!displayGroup) return;

    const payload = new DisplayGroup(
      displayGroup.id,
      name,
      displayGroup.order,
      paths,
    );
    await updateDisplayGroup(payload);

    navigate(routes.displayGroup(sessionCurrentWorkspaceId));
  };

  return (
    <>
      <div className="flex justify-between items-center">
        <PageHeader hasBack title="表示グループ編集" />
        {/* 右上のボタン */}
        <SubmitAndCancelButtons
          isLoading={isLoading}
          onCancel={() => navigate(routes.displayGroup(sessionCurrentWorkspaceId))}
          onSubmit={() => formRef.current?.triggerSubmit()}
          buttonClassName="min-w-40"
        />
      </div>

      {landingPaths
        ? (
          <DisplayGroupForm
            ref={formRef}
            submit={handleUpdateDisplayGroup}
            landingPaths={landingPaths}
            displayGroup={displayGroup}
          />
        )
        : null}
    </>
  );
};

export default DisplayGroupEditPage;
